'use strict';

var React = require('react');
var assign = require('object-assign');

var renderCells = require('./MenuItem/renderCells');
var MenuItem = require('./MenuItem');
var MenuItemFactory = React.createFactory(MenuItem);
var MenuSeparator = require('./MenuSeparator');

module.exports = function (props, state, item, index) {

    var expandedIndex = state.itemProps ? state.itemProps.index : -1;

    if (item === '-') {
        return React.createElement(MenuSeparator, { key: index });
    }

    var className = [props.itemClassName, item.cls, item.className].filter(function (x) {
        return !!x;
    }).join(' ');

    var itemProps = assign({
        className: className,
        key: index,
        data: item,
        columns: props.columns,
        expanded: index === expandedIndex,
        disabled: item.disabled,
        onClick: item.onClick || item.fn
    }, props.itemStyleProps);

    itemProps.children = renderCells(itemProps);

    if (item.items) {
        var Menu = require('./Menu');
        itemProps.children.push(React.createElement(Menu, { items: item.items }));
    }

    return (props.itemFactory || MenuItemFactory)(itemProps);
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-menus/lib/prepareItem.js
 ** module id = 179
 ** module chunks = 0
 **/